/* =============================================
   CATHOU — Theme JavaScript
   ============================================= */

document.addEventListener('DOMContentLoaded', () => {

  // ---- Mobile Menu ----
  const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileMenuOverlay = document.querySelector('.mobile-menu__overlay');
  const mobileMenuClose = document.querySelector('.mobile-menu__close');

  function openMobileMenu() {
    mobileMenu?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    mobileMenu?.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  mobileMenuToggle?.addEventListener('click', openMobileMenu);
  mobileMenuOverlay?.addEventListener('click', closeMobileMenu);
  mobileMenuClose?.addEventListener('click', closeMobileMenu);

  // ---- Cart Drawer ----
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartDrawerOverlay = document.querySelector('.cart-drawer__overlay');
  const cartDrawerClose = document.querySelector('.cart-drawer__close');
  const cartTriggers = document.querySelectorAll('[data-open-cart]');

  function openCart() {
    cartDrawer?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    cartDrawer?.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  cartTriggers.forEach(t => t.addEventListener('click', openCart));
  cartDrawerOverlay?.addEventListener('click', closeCart);
  cartDrawerClose?.addEventListener('click', closeCart);

  // ---- Product Gallery Thumbnails ----
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImage = document.querySelector('.product-gallery__main img');

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      const src = thumb.querySelector('img')?.src;
      if (mainImage && src) {
        mainImage.src = src;
      }
    });
  });

  // ---- Option Pills / Swatches ----
  document.querySelectorAll('.option-pills').forEach(group => {
    group.querySelectorAll('.pill').forEach(pill => {
      pill.addEventListener('click', () => {
        group.querySelectorAll('.pill').forEach(p => p.classList.remove('is-active'));
        pill.classList.add('is-active');
      });
    });
  });

  document.querySelectorAll('.option-swatches').forEach(group => {
    group.querySelectorAll('.swatch').forEach(swatch => {
      swatch.addEventListener('click', () => {
        group.querySelectorAll('.swatch').forEach(s => s.classList.remove('is-active'));
        swatch.classList.add('is-active');
      });
    });
  });

  // ---- Announcement bar auto-cycle (if multiple messages) ----
  const messages = document.querySelectorAll('.announcement-bar__message');
  if (messages.length > 1) {
    let current = 0;
    setInterval(() => {
      messages[current].style.display = 'none';
      current = (current + 1) % messages.length;
      messages[current].style.display = 'block';
    }, 4000);
  }

  // ---- Sticky header shadow on scroll ----
  const header = document.querySelector('.site-header');
  window.addEventListener('scroll', () => {
    if (header) {
      header.style.boxShadow = window.scrollY > 0
        ? '0 2px 16px rgba(0,0,0,0.07)'
        : 'none';
    }
  }, { passive: true });

});
